import { useEffect, useState } from 'react';
import { getSpotOutlook } from '../../api/spots';
import type { SpotOutlookResponse } from '../../types/weather';
import { TodayHeroCard } from './TodayHeroCard';
import { WeekStrip } from './WeekStrip';

export function WeatherOutlookCard({ spotId }: { spotId: number }) {
  const [data, setData] = useState<SpotOutlookResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    setData(null);
    getSpotOutlook(spotId)
      .then(setData)
      .catch(() => setError('Failed to load weather outlook.'))
      .finally(() => setLoading(false));
  }, [spotId]);

  const updatedAt = data
    ? new Date(data.generatedAt).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })
    : null;

  return (
    <div className="rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 p-4 shadow-sm">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-base font-semibold text-slate-900 dark:text-slate-50">
          Weather & Fishing Outlook
        </h3>
        {updatedAt && (
          <span className="text-xs text-slate-500 dark:text-slate-400">Updated {updatedAt}</span>
        )}
      </div>
      {loading && <div className="animate-pulse h-48 rounded bg-slate-100 dark:bg-slate-700" />}
      {error && <p className="text-red-500 text-sm">{error}</p>}
      {data && (
        <>
          <TodayHeroCard today={data.today} />
          <WeekStrip days={data.days} />
        </>
      )}
    </div>
  );
}
